import {
  useFeFilterPresetCreateMutation,
  useFeFilterPresetUpdateMutation,
  useFeFilterPresetDestroyMutation,
} from 'graphql-common';
import { showGraphQLErrors } from '@lib/utils/graphQLErrors';
import { useTranslation } from 'react-i18next';

export default function useMutations() {
  const { t } = useTranslation();
  const [
    fetchFeFilterPresetCreateMutation,
    fetchFeFilterPresetCreateMutationResult,
  ] = useFeFilterPresetCreateMutation({
    onError: (error) => showGraphQLErrors(error, t),
  });
  const [fetchFeFilterPresetUpdateMutation] = useFeFilterPresetUpdateMutation({
    onError: (error) => showGraphQLErrors(error, t),
  });
  const [fetchFeFilterPresetDestroyMutation] = useFeFilterPresetDestroyMutation(
    {
      onError: (error) => showGraphQLErrors(error, t),
    },
  );
  return {
    fetchFeFilterPresetCreateMutation,
    fetchFeFilterPresetCreateMutationResult,
    fetchFeFilterPresetUpdateMutation,
    fetchFeFilterPresetDestroyMutation,
  };
}
